import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { ElNotification } from 'element-plus';
import { getCompanyPort, setCompanyPort, setPublicCompanyPort } from '../config';
import { comonOutLogin } from './common';

interface ApiResponse<T = any> {
  code: number;
  msg: string;
  data: T;
}

export default class ApiService {
  private axiosInstance: AxiosInstance;

  constructor() {
    // Set your baseURL, headers, and token here
    this.axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_URL,
      headers: {
        'Content-Type': 'application/json',
        // You can add other default headers here
      },
    });

    // Set token if available
    const token = this.getToken();
    if (token) {
      this.setTokenHeader(token);
    }

    this.setupInterceptors();
  }

  private setupInterceptors() {
    this.axiosInstance.interceptors.request.use(
      (config) => {
        // You can modify the request config here, such as adding headers or authentication tokens
         const token = this.getToken();
        if (token) {
          config.headers = config.headers || {};
          config.headers['Authorization'] = `${token}`;
        }
        return config;
      },
      (error) => {
        // Handle request error
        return Promise.reject(error);
      }
    );

    this.axiosInstance.interceptors.response.use(
      (response) => {
        // You can modify the response data here
        if (response.config.responseType == "blob") {
          if (response.data.type == 'application/zip') {
            return response;
          } else {
            const { code, msg, data } = response.data as ApiResponse;
            if (code == -10000) {
              setCompanyPort('');
              window.localStorage.setItem('v3token', '');
              window.localStorage.setItem('v3userInfo', '');
              ElNotification.error({
                title: '错误',
                message: '登陆过期,请重新登陆'
              });
              if (process.env.NODE_ENV == 'production' && process.env.VUE_APP_URL.indexOf('https://gyl.muyu-tech.cn') != -1) {
                // 这是牧予供应链的退出,并且还是线上环境
                comonOutLogin();
              } else {
                window.location.href = `${window.location.pathname}#/`;
              }
              // window.location.href = '/cg/admin/#/login';
              return Promise.reject(new Error('登陆过期,请重新登陆'));
            } else {
              ElNotification.error({
                title: '错误',
                message: '导出失败'
              });
              return Promise.reject(new Error(msg));
            }
          }
        }
        const { code, msg, data } = response.data as ApiResponse;
        if (code === 0) {
          return response;
        } else if (code == -10000) {
          ElNotification.error({
            title: '错误',
            message: '登陆过期,请重新登陆'
          });
          setCompanyPort('');
          setPublicCompanyPort('');
          window.localStorage.setItem('v3token', '');
          window.localStorage.setItem('v3userInfo', '');
          // window.location.href = '/cg/admin/#/login';
          if (process.env.NODE_ENV == 'production' && process.env.VUE_APP_URL.indexOf('https://gyl.muyu-tech.cn') != -1) {
            // 这是牧予供应链的退出,并且还是线上环境
            comonOutLogin();
          } else {
            window.location.href = `${window.location.pathname}#/`;
          }
          return Promise.reject(new Error('登陆过期,请重新登陆'));
        } else {
          ElNotification.error({
            title: '错误',
            message: msg
          });
          return Promise.reject(new Error(msg));
        }
      },
      (error) => {
        // Handle response error
        this.handleErrorResponse(error);
        return Promise.reject(error);
      }
    );
  }

  private handleErrorResponse(error: any) {
    if (error.config.url.indexOf('/login') != -1) {
      ElNotification.error({
        title: '失败',
        message: '账号密码错误'
      });
      setCompanyPort('');
      return;
    }
    // Custom logic to handle different types of errors
    if (error.response) {
      // The request was made, but the server responded with a status code outside of the 2xx range
      console.error('Response error:', error.response.status, error.response.data);
      ElNotification.error({
        title: '失败',
        message: error.response.data
      });
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Request error:', error.request);
      ElNotification.error({
        title: '失败',
        message: error.request
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error:', error.message);
      ElNotification.error({
        title: '失败',
        message: error
      });
    }
  }

  private getToken(): string | null {
    // Implement logic to retrieve token from wherever it's stored (e.g., localStorage, cookies, etc.)
    let token: string | null = window.localStorage.getItem('v3token');
    return token;
  }

  private setTokenHeader(token: string): void {
    this.axiosInstance.defaults.headers.common['Authorization'] = `${token}`;
  }

  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const isFullUrl = /^https?:\/\//.test(url);
    if (!isFullUrl && getCompanyPort()) {
      url = getCompanyPort() + url;
    }

    return this.axiosInstance.get<ApiResponse<T>>(url, config).then((response) => response.data as unknown).then((data) => data as T);
  }
  
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const isFullUrl = /^https?:\/\//.test(url);
    if (!isFullUrl && getCompanyPort()) {
      url = getCompanyPort() + url;
    }

    return this.axiosInstance.post<ApiResponse<T>>(url, data, config).then((response) => response.data as unknown).then((data) => data as T);
  }

  // You can add other HTTP methods (put, delete, etc.) as needed

  // You can also add other helper methods as needed
}

